import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

import { BannerSeverity } from './types';

@Component({
  selector: 'mimecast-ui-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FontAwesomeModule],
})
export class BannerComponent {
  @Input()
  severity: BannerSeverity = 'info';

  @Input()
  titleText?: string | null;

  @Input()
  message?: string | TemplateRef<ElementRef> | null;

  @Input()
  showIcon = true;

  @Input()
  showCloseIcon = true;

  @Output()
  closed = new EventEmitter<void>();

  protected readonly severityIcons: Record<BannerSeverity, IconProp> = {
    info: faCircleInfo as IconProp,
    warn: faTriangleExclamation as IconProp,
    error: faCircleExclamation as IconProp,
    success: faCircleCheck as IconProp,
  };

  protected readonly closeIcon = faXmark as IconProp;

  protected readonly dismissAria: Record<BannerSeverity, string> = {
    error: $localize`Dismiss error`,
    warn: $localize`Dismiss warning`,
    info: $localize`Dismiss message`,
    success: $localize`Dismiss success`,
  };

  protected readonly severityIconAria: Record<BannerSeverity, string> = {
    error: $localize`Error notification`,
    warn: $localize`Warning notification`,
    info: $localize`Information`,
    success: $localize`Success`,
  };

  isTemplateRef(value: unknown): value is TemplateRef<ElementRef> {
    return value instanceof TemplateRef;
  }
}
